module.exports = __webpack_public_path__ + "static/media/DTDC.0c9d7ba2.svg";